module.exports = __webpack_public_path__ + "static/media/28.417e0198.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/28.svg
// module id = 139
// module chunks = 0